exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".SingleLineEditor-c6593af1{position:relative;min-height:60px}.SingleLineEditor-c6593af1.clamp-1913414a{min-height:auto;height:20px;overflow:hidden;-webkit-line-clamp:1;text-overflow:ellipsis;overflow:hidden;display:-webkit-box;-webkit-box-orient:vertical;word-wrap:break-word}\n", ""]);

// Exports
exports.locals = {
	"SingleLineEditor": "SingleLineEditor-c6593af1",
	"clamp": "clamp-1913414a"
};